import {
  AppRegion,
  currencyDecimals,
  currencySign,
  DEFAULT_CURRENCY,
} from '@ca/common'
import { useTranslation } from 'react-i18next'
import { useRemoteConfig } from './useRemoteConfigStore'
import { useMemo } from 'react'
import AppConfig from 'config'
import { useAppRegion } from 'storage/useRemoteConfigParams'

/**
 * Prefer to use the locale code than just plain language code
 * ie en-DE instead of en
 */
export const getLocaleCode = (language: string, region: AppRegion) => {
  const countryCode = region.code
  return `${language}-${countryCode.toUpperCase()}`
}

export const usePriceFormatter = () => {
  const { i18n } = useTranslation()
  const config = useRemoteConfig()
  const region = useAppRegion()
  const locale = getLocaleCode(i18n.language, region)
  const currency = config?.region.currency || DEFAULT_CURRENCY

  const formatter = useMemo(
    () =>
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
      }),
    [locale, currency]
  )
  return formatter
}

export const usePrice = (value: number) => {
  const formatter = usePriceFormatter()
  return formatter.format(value)
}

export const useCurrencySign = () => {
  const config = useRemoteConfig()
  const currency = config?.region.currency || DEFAULT_CURRENCY
  return currencySign[currency]
}

export const useCurrencyDecimals = () => {
  const config = useRemoteConfig()
  const currency = config?.region.currency || DEFAULT_CURRENCY
  return currencyDecimals[currency]
}
